<template>
    <my-tag :type="setting.type">{{setting.text}}</my-tag>
</template>
<script>
export default {
    props: {
        readonly: {
            type: [Boolean, Number, String],
            default: false
        }
    },
    data: () => ({
        switchObj: {
            'true': {
                type: 'danger',
                text: '已内审或发布，不满足退回条件！'
            },
            'false': {
                type: 'success',
                text: '未发布'
            }
        }
    }),
    computed: {
        setting() {
            return this.switchObj[!!this.readonly] || {};
        }
    }
}
</script>
<style lang="scss" scoped>

</style>